export type FeaturedDocType = 'process' | 'ksa' | 'dca'

export interface FeaturedDoc {
  nodeId: string
  docType: FeaturedDocType
  name: string
  description: string
}

const DEFAULT_FEATURED: FeaturedDoc = {
  nodeId: 'mrkt_rsrch_analysis_procdoc_id',
  docType: 'process',
  name: 'Market Research and Analysis Process Document',
  description:
    'How the practice studies its local market and target patients to drive customer-acquisition decisions. A natural entry point for advisor-led discussions about growth and positioning.',
}

const PER_COMPANY: Record<number, FeaturedDoc> = {
  6: DEFAULT_FEATURED,
}

export function featuredDocFor(companyId: number | null | undefined): FeaturedDoc | null {
  if (companyId === null || companyId === undefined) return null
  return PER_COMPANY[companyId] ?? DEFAULT_FEATURED
}
